import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Divider } from '@telus-uds/components-web';

import InfoListRow from './infoListRow';
import { TankDetailsMain } from './css';

const InfoList = ({
  typeKey,
  tankDetailsFarmAndRanch,
  setTankDetailsFarmAndRanch
}) => {
  return (
    <>
      <Divider space={3} variant={{ inverse: true }} />
      <TankDetailsMain>
        {_.get(tankDetailsFarmAndRanch, typeKey, []).map((row, index) => (
          <InfoListRow
            key={`InfoListItem-${index + 1}`}
            rowIndex={index}
            row={row}
            typeKey={typeKey}
            tankDetailsFarmAndRanch={tankDetailsFarmAndRanch}
            setTankDetailsFarmAndRanch={setTankDetailsFarmAndRanch}
          />
        ))}
      </TankDetailsMain>
    </>
  );
};

InfoList.propTypes = {
  typeKey: PropTypes.string.isRequired,
  tankDetailsFarmAndRanch: PropTypes.shape({
    fuelGauge: PropTypes.arrayOf(PropTypes.shape({})),
    fuelPressure: PropTypes.arrayOf(PropTypes.shape({})),
    propane: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  setTankDetailsFarmAndRanch: PropTypes.func.isRequired
};

export default InfoList;
